import { Grid } from '@mui/material';
import { TicketSoldCard } from './components/TicketSoldCard';
import { FunctionComponent } from 'react';
import { useGetStatisticsQuery } from '../../liftoperator';
import { Environment } from '../../environment';
import { useTranslation } from 'react-i18next';

type TicketSalesStatisticsProps = {
    environments: Environment[];
};

export const TicketSalesStatistics: FunctionComponent<
    TicketSalesStatisticsProps
> = ({ environments }) => {
    const { data: salesStatistics = {} } = useGetStatisticsQuery({
        environments: environments,
    });
    const { t } = useTranslation();

    return (
        <Grid
            spacing={{ xs: 2, md: 3 }}
            sx={{
                mb: 6,
            }}
            container
        >
            <Grid xs={12} sm={6} md={4} item>
                <TicketSoldCard
                    ticketsSold={salesStatistics['ticketsYesterday'] ?? 0}
                    description={t('ticketsStartYesterday')}
                />
            </Grid>

            <Grid xs={12} sm={6} md={4} item>
                <TicketSoldCard
                    ticketsSold={salesStatistics['ticketsToday'] ?? 0}
                    description={t('ticketsStartToday')}
                />
            </Grid>

            <Grid xs={12} sm={6} md={4} item>
                <TicketSoldCard
                    ticketsSold={salesStatistics['ticketsTomorrow'] ?? 0}
                    description={t('ticketsStartTomorrow')}
                />
            </Grid>

            <Grid xs={12} sm={6} md={4} item>
                <TicketSoldCard
                    ticketsSold={salesStatistics['ticketsSoldYesterday'] ?? 0}
                    description={t('ticketsSoldYesterday')}
                />
            </Grid>

            <Grid xs={12} sm={6} md={4} item>
                <TicketSoldCard
                    ticketsSold={salesStatistics['ticketsSoldToday'] ?? 0}
                    description={t('ticketsSoldToday')}
                />
            </Grid>

            <Grid xs={12} sm={6} md={4} item>
                <TicketSoldCard
                    ticketsSold={Math.round(
                        salesStatistics['ticketsSoldAverage'] ?? 0
                    )}
                    description={t('ticketsSoldAvg')}
                />
            </Grid>
        </Grid>
    );
};
